/**
 * utils.js
 * Funciones de utilidad compartidas entre módulos.
 */

/**
 * Escapa caracteres HTML especiales para prevenir XSS.
 * Usar siempre que se inserte texto de datos externos en innerHTML.
 * @param {string} texto
 * @returns {string}
 */
export function escaparHTML(texto) {
  return String(texto)
    .replaceAll('&',  '&amp;')
    .replaceAll('<',  '&lt;')
    .replaceAll('>',  '&gt;')
    .replaceAll('"',  '&quot;')
    .replaceAll("'",  '&#39;');
}